import { render, staticRenderFns } from "./SendInvoiceModal.vue?vue&type=template&id=195bde42&scoped=true&"
import script from "./SendInvoiceModal.vue?vue&type=script&lang=ts&"
export * from "./SendInvoiceModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195bde42",
  null
  
)

export default component.exports